<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
        <p class="modal-card-title">Need Support?</p>
    </header>
    <section class="modal-card-body">
      <p>Provide us your contact information and a detailed description about the issues you're having and we'll be in touch.</p>
      <div class="my-6">
        <b-field label="Name" horizontal>
          <b-field 
            :type="getFieldTypesFromValidationPath('first_name')"
            :message="getFieldMessages('first_name')">
            <b-input name="first_name" v-model.trim="$v.first_name.$model" expanded :loading="$wait.is(supportRequestLoader)" :disabled="$wait.any" @input.native="set"></b-input>
          </b-field>
          <b-field 
            :type="getFieldTypesFromValidationPath('last_name')"
            :message="getFieldMessages('last_name')">
            <b-input name="last_name" v-model.trim="$v.last_name.$model" expanded :loading="$wait.is(supportRequestLoader)" :disabled="$wait.any" @input.native="set"></b-input>
          </b-field>
        </b-field>
        <b-field label="Email" horizontal
          :type="getFieldTypesFromValidationPath('email')"
          :message="getFieldMessages('email')">
          <b-input type="email" name="email" v-model.trim="$v.email.$model" expanded :loading="$wait.is(supportRequestLoader)" :disabled="$wait.any" @input.native="set"></b-input>
        </b-field>
        <b-field label="Phone" horizontal
          :type="getFieldTypesFromValidationPath('phone')"
          :message="getFieldMessages('phone')">
          <b-input type="tel" name="phone" v-model.trim="$v.phone.$model" expanded :loading="$wait.is(supportRequestLoader)" :disabled="$wait.any" @input.native="set"></b-input>
        </b-field>
        <b-field label="Category" horizontal
          :type="getFieldTypesFromValidationPath('category')"
          :message="getFieldMessages('category')">
          <b-select name="category" placeholder="Select a Support Category" v-model.trim="$v.category.$model" expanded :loading="$wait.is(supportRequestLoader)" :disabled="$wait.any" @input.native="set">
              <option value="Product Requests">Product Requests</option>
              <option value="Account Information">Account Information</option>
              <option value="Other">Other</option>
          </b-select>
        </b-field>
        <b-field label="Notes" horizontal
          :type="getFieldTypesFromValidationPath('notes')"
          :message="getFieldMessages('notes')">
          <b-input type="textarea" name="notes" v-model.trim="$v.notes.$model" expanded :loading="$wait.is(supportRequestLoader)" :disabled="$wait.any" @input.native="set"></b-input>
        </b-field>
        <b-field label="" horizontal>
          <b-button type="is-primary" :loading="$wait.is(supportRequestLoader)" :disabled="! isSupportRequestSubmittable" @click="submitSupportRequest"><i class="sl-mail-1"></i> Submit Support Request</b-button>
        </b-field>
      </div>
    </section>
    <footer class="modal-card-foot" style="justify-content: flex-end">
    </footer>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'

import { validations, messages } from '@/plugins/vuelidate/validations/support-request-modal'

export default {
  data: function () {
    return {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      category: '',
      notes: '',
      messages: messages,
      apiValidationErrors: {}
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    supportRequestLoader () {
      return 'creating support request'
    },
    supportRequestPathSubset () {
      return ['first_name', 'last_name', 'email', 'phone', 'notes']
    },
    supportRequestPropertySubset () {
      return this.getPropertiesFromPaths(this.supportRequestPathSubset)
    },
    isDirty () {
      return this.isSupportRequestDirty
    },
    isSupportRequestDirty () {
      return this.$v.first_name.$dirty || this.$v.last_name.$dirty || this.$v.email.$dirty || this.$v.phone.$dirty || this.$v.notes.$dirty 
    },
    isSaving () {
      return this.$wait.is([this.supportRequestLoader])
    },
    supportRequestHasErrors () {
      return this.$v.$error
    },
    isSupportRequestSubmittable () {
      return ! this.isSaving && this.isSupportRequestDirty && ! this.supportRequestHasErrors
    },
  },
  methods: {
    ...mapActions([
      'sendSupportRequestEmail'
    ]),
    set (e) {
      this.clearApiValidationFailures(e.target.name)
      this[e.target.name] = e.target.value
      this.$v[e.target.name].$touch()
    },
    failedApiValidation (property) {
      return false
    },
    clearApiValidationFailures (property) {
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        delete this.apiValidationErrors[property]
      }
    },
    getFieldTypesFromValidationPath (validationPath) {
      return {
        'is-danger': eval(`this.$v.${ validationPath }.$error`)
      }
    },
    getFieldMessages(validationPath) {
      let validationPathArray = validationPath.split('.')
      return {...this.getFieldMessagesFromValidationPath(validationPath), ...this.getFieldMessagesFromFailedApiValidation(validationPathArray.pop())}
    },
    getFieldMessagesFromFailedApiValidation (property) {
      let fieldMessages = {}
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        fieldMessages[this.apiValidationErrors[property]] = true
      }
      return fieldMessages
    },
    getFieldMessagesFromValidationPath (validationPath) {
      let validationPathArray = validationPath.split('.')
      let messages = this.messages

      while (validationPathArray.length) {
        messages = messages[validationPathArray.shift()]
      }

      let fieldMessages = {}

      for (const validation in messages) {
        fieldMessages[messages[validation]] = eval(`this.$v.${ validationPath }.$error && ! this.$v.${ validationPath }.${ validation }`)
      }

      return fieldMessages
    },
    toggleSupportRequestModal (display) {
      this.isSupportRequestModalActive = display
    },
    isValid (pathSubset) {
      let invalid = false
      for(const path of pathSubset) {
        eval(`this.$v.${ path }.$touch()`)
        invalid = invalid || eval(`this.$v.${ path }.$invalid`)
      }
      if (invalid) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please fix the indicated fields'
        })
        return
      }
      return true
    },
    validate (pathSubset) {
      if (! this.isValid(pathSubset)) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please fix the indicated fields'
        })
        return
      }
      return true
    },
    async submitSupportRequest (e) {
      if (this.isValid(this.supportRequestPathSubset)) {
        this.$wait.start(this.supportRequestLoader)
        try {
          await this.sendSupportRequestEmail({
            data: {
              'first_name': this.first_name,
              'last_name': this.last_name,
              'email': this.email,
              'phone': this.phone,
              'category': this.category,
              'notes': this.notes,
            }
          })
          this.$wait.end(this.supportRequestLoader)
          this.toggleSupportRequestModal(false)
          this.$buefy.toast.open({
            message: 'Your support request was received. We will be in touch shortly. Thank you.',
            type: 'is-success',
            position: 'is-top',
            duration: 5000,
          })
        } catch (error) {
          console.log(error)
          this.$wait.end(this.supportRequestLoader)
          this.$buefy.dialog.alert({
            type: 'is-danger',
            title: 'Error',
            message: 'Unable to send support request. Please try again.',
          })
          return false
        }
      }
    },
    mounted () {
      this.$nextTick(function () {
        if (! isEmpty(this.user)) {
          this.first_name = this.user.first_name
          this.last_name = this.user.last_name
          this.email = this.user.email
        }
        this.$v.$reset()
      })
    },
  },
  validations: validations,
}
</script>

